import { render, staticRenderFns } from "./BulkDuplicateTool.vue?vue&type=template&id=3f5c8daf&scoped=true&"
import script from "./BulkDuplicateTool.vue?vue&type=script&lang=js&"
export * from "./BulkDuplicateTool.vue?vue&type=script&lang=js&"
import style0 from "./BulkDuplicateTool.vue?vue&type=style&index=0&id=3f5c8daf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c8daf",
  null
  
)

export default component.exports